import React from 'react';
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import useTheme from "@material-ui/core/styles/useTheme";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Footer from './Footer';
const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(4, 0),
        width: '100%',
    },
    container: {
        maxWidth: theme.maxContentWidth,
        margin: '0 auto',
        padding: theme.spacing(0, 2),
    },
    title: {
        marginBottom: theme.spacing(4),
    },
    section: {
        marginBottom: theme.spacing(4),
    },
    sectionTitle: {
        marginBottom: theme.spacing(2),
    },
    paragraph: {
        marginBottom: theme.spacing(2),
    },
}));

const PrivacyPolicy = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

    return (
        <Box className={classes.root}>
            <Container className={classes.container}>
                <Typography variant="h3" component="h1" className={classes.title}>
                    {t('privacy_policy')}
                </Typography>

                <Box className={classes.section}>
                    <Typography variant="h5" component="h2" className={classes.sectionTitle}>
                        {t('privacy_section_1_title')}
                    </Typography>
                    <Typography variant="body1" className={classes.paragraph}>
                        {t('privacy_section_1_content')}
                    </Typography>
                </Box>

                <Box className={classes.section}>
                    <Typography variant="h5" component="h2" className={classes.sectionTitle}>
                        {t('privacy_section_2_title')}
                    </Typography>
                    <Typography variant="body1" className={classes.paragraph}>
                        {t('privacy_section_2_content')}
                    </Typography>
                </Box>

                <Box className={classes.section}>
                    <Typography variant="h5" component="h2" className={classes.sectionTitle}>
                        {t('privacy_section_3_title')}
                    </Typography>
                    <Typography variant="body1" className={classes.paragraph}>
                        {t('privacy_section_3_content')}
                    </Typography>
                </Box>

                <Box className={classes.section}>
                    <Typography variant="h5" component="h2" className={classes.sectionTitle}>
                        {t('privacy_section_4_title')}
                    </Typography>
                    <Typography variant="body1" className={classes.paragraph}>
                        {t('privacy_section_4_content')}
                    </Typography>
                </Box>

                <Box className={classes.section}>
                    <Typography variant="h5" component="h2" className={classes.sectionTitle}>
                        {t('privacy_section_5_title')}
                    </Typography>
                    <Typography variant="body1" className={classes.paragraph}>
                        {t('privacy_section_5_content')}
                    </Typography>
                </Box>
            </Container>
            <Footer />
        </Box>
    );
};

export default PrivacyPolicy; 